import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {

	return {
		popularContentWrapper: {
			display       : "flex",
			flexDirection : "column",
			margin        : "3rem 0",
			width         : "100%",

			[rooterMediaQuery.tablet]: {
				padding: "0 4rem"
			},

			[rooterMediaQuery.mobile]: {
				margin : "1rem 1.6rem",
				width  : "unset"
			}
		},
		headerWrapper: {
			display      : "flex",
			marginBottom : "2rem",

			[rooterMediaQuery.mobile]: {
				marginBottom: "1rem"
			}
		},
		heading: {
			fontSize    : "1.5rem",
			marginRight : "4px",

			[rooterMediaQuery.mobile]: {
				fontSize: "1.2rem"
			}

		},
		name: {
			fontSize   : "1.5rem",
			fontWeight : "500",

			[rooterMediaQuery.mobile]: {
				fontSize: "1.2rem"
			}
		},
		content: {
			display : "flex",
			gap     : "2rem"
		},

		horizontalVideosContainer: {
			display             : "grid",
			gridTemplateColumns : "repeat(4, 1fr)",
			gridGap             : "2.5rem",
			// padding             : "2rem 0",

			[rooterMediaQuery.tablet]: {
				gridAutoFlow        : "column",
				gridAutoColumns     : "45% 45%",
				overflowX           : "auto",
				gridTemplateColumns : "unset"
			}
		},

		// mobile css
		mobileVideosContainer: {
			overflowX           : "auto",
			gridAutoFlow        : "column",
			gridAutoColumns     : "80%",
			gridTemplateColumns : "unset",
			gridGap             : "1rem",
			display             : "grid",

			// remove scrollbar
			msOverFlowStytle       : "none", /* Internet Explorer 10+ */
			scrollBarWidth         : "none", /* Firefox */
			"&::-webkit-scrollbar" : {
				display: "none" /* Safari and Chrome */
			}
		},

		// video card
		mobileVideoCardContainer: {
			position: "relative"
		},
		imageContainer: {
			paddingTop: "56.25%"
		},
		image: {
			top          : "0%",
			position     : "absolute",
			objectFit    : "cover",
			aspectRatio  : "16 / 9",
			borderRadius : "1rem"
		},

		tagsContianer: {
			position : "absolute",
			top      : "0%",
			display  : "flex"
		},

		cardInfoContainer: {
			position   : "absolute",
			display    : "flex",
			bottom     : "2%",
			alignItems : "center",
			left       : "2%"
		},

		backgroundOverlay: {
			position   : "absolute",
			background : "linear-gradient(180deg,transparent,rgba(0,0,0,.008) 11.79%,rgba(0,0,0,.031) 21.38%,rgba(0,0,0,.067) 29.12%,rgba(0,0,0,.115) 35.34%,rgba(0,0,0,.172) 40.37%,rgba(0,0,0,.239) 44.56%,rgba(0,0,0,.312) 48.24%,rgba(0,0,0,.39) 51.76%,rgba(0,0,0,.472) 55.44%,rgba(0,0,0,.556) 59.63%,rgba(0,0,0,.64) 64.66%,rgba(0,0,0,.724) 70.88%,rgba(0,0,0,.804) 78.62%,rgba(0,0,0,.88) 88.21%,rgba(0,0,0,.95))",
			width      : "100%",
			bottom     : "0",
			height     : "50%"
		},

		profileImg: {
			height       : "4rem",
			width        : "4rem",
			borderRadius : "100%",
			marginRight  : "1rem"
		},

		videoTitle: {
			fontSize : "1.2rem",
			width    : "80%"
		},

		creatorName: {
			fontSize: "1rem"
		}
	};
} );

